var _arity =
/*#__PURE__*/
require("./_arity.js");

var _curry2 =
/*#__PURE__*/
require("./_curry2.js");

function _createPartialApplicator(concat) {
  return _curry2(function (fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}

module.exports = _createPartialApplicator;